import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/kadl/";

export default class KADLApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getKADLs(params) {
    return await request.post(`${rootRoute}getKADLs`, {
      filter: params,
      parameters: {},
    });
  }
  async getKADL(id) {
    return await request.post(`${rootRoute}getKADLs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createKADL(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createKADL`, { data });
  }
  async deleteKADL(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteKADL`, { data });
  }
  async editKADL(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateKADL`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importKADL`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getKADLimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportKADL`, {
      filter: filter,
      format: format
    });
  }
}
